import React, { useState } from "react";

import { Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import blog from "../../../src/assets/img/blog.jpeg";
import playstore from "../../../src/assets/img/badge_googleplay.svg";
import appstore from "../../../src/assets/img/badge_appstore.svg";
import myploscreen from "../../../src/assets/img/footerBatch.png";
import { useLocation } from "react-router";
import { imgBaseURL } from "helper/Utility";
import AppPlayStore from "views/Component/AppPlayStore";
import HTMLContent from "helper/my-com/HTMLContent";
const BlogDetails = () => {
  const location = useLocation();
  const blogData = location?.state ? location?.state : null
  return (
    <>
      <div className="margindiv-header">
        <div className="myplo_aboutus_page">
          <Container>
            <div className="row pb-lg-5">
              <div className="col-lg-8 mx-auto">
                <div className="blog-detail-pag">
                  <img className="img-blog-details"src={blogData?.image ? imgBaseURL() + blogData?.image : blog} alt="img" />
                  <h1>{blogData?.title}</h1>
                  <div className="key-box-inner"><HTMLContent  data={blogData?.content}/></div>
                </div>
              </div>
            </div>
          </Container>
        </div>

        <AppPlayStore />

      </div>
    </>
  );
};

export default BlogDetails;
